import { createSlice } from "@reduxjs/toolkit"

export type PlaybackEntityType = "video" | "locationShare"
export type PlaybackEntity = { type: PlaybackEntityType; id: string }

type PlaybackState = {
    openPlaybackEntities: PlaybackEntity[]
    pictureInPictureId: string | undefined
    followingEntity: PlaybackEntity | undefined
}
const initialState: PlaybackState = {
    openPlaybackEntities: [],
    pictureInPictureId: undefined,
    followingEntity: undefined,
}

export const playbackSliceName = "playback" as const

export const {
    reducer: playbackSliceReducer,
    actions: {
        openPlayback,
        closePlayback,
        togglePlayback,
        setPictureInPictureId,
        setFollowingEntity,
    },
} = createSlice({
    name: playbackSliceName,
    initialState,
    reducers: {
        openPlayback: (state, action: { payload: PlaybackEntity }) => {
            const { id } = action.payload
            const existingIndex = state.openPlaybackEntities.findIndex((e) => e.id === id)
            if (existingIndex !== -1) {
                state.openPlaybackEntities.splice(existingIndex, 1)
            }
            state.openPlaybackEntities.push(action.payload)
        },
        closePlayback: (state, action: { payload: { id: string } }) => {
            const { id } = action.payload
            const existingIndex = state.openPlaybackEntities.findIndex((e) => e.id === id)
            if (existingIndex !== -1) {
                state.openPlaybackEntities.splice(existingIndex, 1)
            }
            if (state.pictureInPictureId === id) {
                state.pictureInPictureId = undefined
            }
        },
        togglePlayback: (state, action: { payload: PlaybackEntity }) => {
            const { id } = action.payload
            const existingIndex = state.openPlaybackEntities.findIndex((e) => e.id === id)
            if (existingIndex !== -1) {
                state.openPlaybackEntities.splice(existingIndex, 1)
                if (state.pictureInPictureId === id) {
                    state.pictureInPictureId = undefined
                }
            } else {
                state.openPlaybackEntities.push(action.payload)
            }
        },
        setPictureInPictureId: (state, action: { payload: { id: string | undefined } }) => {
            state.pictureInPictureId = action.payload.id
        },
        setFollowingEntity: (state, action: { payload: PlaybackEntity | undefined }) => {
            state.followingEntity = action.payload
        },
    },
})
